export default {
    classType: 'components',

    init() {
        // display the homepage background image
        if (appData.page.vars.landingBackground) {
            let updateBackground = () => {
                // check the existence of md breaking point
                if (appData.displayBreakpoints.md === undefined) {
                    console.warn(
                        'The md breaking point is not defined,' +
                            'this will lead to a badly displayed background image on the homepage.'
                    );
                }
                // mobile = less than medium screen (>= xs and sm)
                let isMobile =
                    document.documentElement.clientWidth <
                    appData.displayBreakpoints.md;
                let path = '';
                if (isMobile) {
                    // use the mobile background image
                    let arr = appData.page.vars.landingBackground.split('/');
                    // The mobile images are stored in '/mobile' sub-directory
                    // Update this var if you want to change the file architecture
                    let mobileFolderName = 'mobile';
                    arr.splice(-1, 0, mobileFolderName);
                    path = arr.join('/');
                } else {
                    // use the full size image
                    path = appData.page.vars.landingBackground;
                }

                let url = 'url("' + this.app.getDomain() + path + '.jpg")';
                // Prevent trigger useless assignation events.
                if (this.el.style.backgroundImage !== url) {
                    this.el.style.backgroundImage = url;
                }
            };

            updateBackground();

            window.addEventListener('resize', updateBackground);
        }
    },
};
